import { Checkbox } from '@/components/ui'

interface OrganizeStepProps {
  updateExisting: boolean
  onChange: (value: boolean) => void
}

export default function OrganizeStep({ updateExisting, onChange }: OrganizeStepProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
      <div>
        <h3 style={{ fontSize: '16px', fontWeight: 500, color: '#111827', marginBottom: '8px' }}>
          How should we handle existing attendees?
        </h3>
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          When a matching attendee is found, choose whether to update their data or skip them.
        </p>
      </div>

      <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px' }}>
        <Checkbox
          checked={updateExisting}
          onChange={(e) => onChange(e.target.checked)}
        >
          <div style={{ marginLeft: '8px' }}>
            <span style={{ fontWeight: 500 }}>Update any existing contacts</span>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              When checked, existing attendee records will be updated with the imported data.
              When unchecked, duplicate records will be skipped.
            </p>
          </div>
        </Checkbox>
      </div>

      <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '16px' }}>
        <p style={{ fontSize: '14px', color: '#1e40af' }}>
          <strong>Note:</strong> {updateExisting
            ? 'Existing attendees will have their data replaced with values from the import file. Empty values in the CSV will not overwrite existing data.'
            : 'Attendees that already exist (based on your identifier choice) will be skipped during import.'
          }
        </p>
      </div>
    </div>
  )
}
